import { showError } from "@/utils/toast";

interface IBGEState {
  id: number;
  sigla: string;
  nome: string;
}

interface IBGECity {
  id: number;
  nome: string;
}

const IBGE_API_BASE_URL = "https://servicodados.ibge.gov.br/api/v1/localidades";

export const fetchStates = async (): Promise<IBGEState[]> => {
  try {
    const response = await fetch(`${IBGE_API_BASE_URL}/estados?orderBy=nome`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: IBGEState[] = await response.json();
    return data;
  } catch (error) {
    showError(`Erro ao carregar estados: ${error instanceof Error ? error.message : "Falha na conexão"}`);
    console.error("Error fetching states:", error);
    throw error;
  }
};

export const fetchCitiesByState = async (stateUf: string): Promise<IBGECity[]> => {
  try {
    const response = await fetch(`${IBGE_API_BASE_URL}/estados/${stateUf}/municipios?orderBy=nome`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: IBGECity[] = await response.json();
    return data;
  } catch (error) {
    showError(`Erro ao carregar cidades para ${stateUf}: ${error instanceof Error ? error.message : "Falha na conexão"}`);
    console.error(`Error fetching cities for ${stateUf}:`, error);
    throw error;
  }
};